import { ExporttocsvService, csvCurrency } from '../../../../services/exporttocsv/exporttocsv.service';
import { Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TransactionsService } from '../../../../services/transactions/transactions.service';
import { TeamsService } from '../../../../services/teams/teams.service';
import { MatSort } from '@angular/material/sort';
import { AllowanceAllocationReportInterface } from './allowance-allocation-report.interface';
import { MatTableDataSource } from '@angular/material/table';
import { Chart } from 'chart.js';

@Component({
    selector: 'app-analytics-allowance-allocation-report',
    templateUrl: './analytics-allowance-allocation-report.component.html',
    styleUrls: ['./analytics-allowance-allocation-report.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AnalyticsAllowanceAllocationReportComponent implements OnInit {
    @ViewChild(MatSort) sort!: MatSort;
    private teamId = '';
    public allowanceAllocationList: MatTableDataSource<AllowanceAllocationReportInterface> = new MatTableDataSource<AllowanceAllocationReportInterface>([]);
    public columnsToDisplay: string[] = ['month', 'monthlyAllowanceSent', 'monthlyAllowanceSpent'];
    public chart: any = [];

  exportCsv(title: string): void {
    this.csvExport.exportTable(title, this.allowanceAllocationList, {
      "month": {header: "Month", value: (element: any) => element.month ?? '---'},
      "monthlyAllowanceSent": {header: "Monthly Allowances Sent ($)", value: (element: any) => (csvCurrency(element.monthlyAllowanceSent)) ?? 0},
      "monthlyAllowanceSpent": {header: "Monthly Allowances Spent ($)", value: (element: any) => (csvCurrency(element.monthlyAllowanceSpent)) ?? 0},
    }, this.columnsToDisplay, {exclude: ['action', 'actionmenu']});
  }

  constructor(
        private transactionService: TransactionsService,
        private teamService: TeamsService,
      private csvExport: ExporttocsvService
  ) { }

    ngOnInit(): void {
        this.teamService.wellspaceChangedObservable.subscribe((team: any): void => {
            if (team && team.id) {
                this.teamId = team.id;
                this.getAllowanceAllocationList();
            }
        });
    }

    getAllowanceAllocationList(): void {
        if (this.teamId) {
            this.allowanceAllocationList.data = [];
            this.transactionService.getAllowanceAllocationReport(this.teamId).then((allowanceAllocationReportData: AllowanceAllocationReportInterface[]): void => {
                this.allowanceAllocationList.data = allowanceAllocationReportData;
                this.allowanceAllocationList.sort = this.sort;
                this.setChart(allowanceAllocationReportData);
            }).catch(err => {
                this.allowanceAllocationList.data = [];
                console.error('Error in get allowance allocation report', err);
            });
        }
    }


    setChart(allowanceAllocationReportData: AllowanceAllocationReportInterface[]): void {
        if (this.teamId) {
            this.chart = new Chart('chart', {
                type: 'line',
                data: {
                    labels: allowanceAllocationReportData.map(report => report.month),
                    datasets: [
                        {
                            label: 'Monthly Allowances Sent ($)',
                            data: allowanceAllocationReportData.map(report => report.monthlyAllowanceSent),
                        },
                        {
                            label: 'Monthly Allowances Spent ($)',
                            data: allowanceAllocationReportData.map(report => report.monthlyAllowanceSpent),
                        }
                    ],
                },
                options: {
                    responsive: true,
                    plugins: {
                        tooltip: {
                            callbacks: {
                                label: function(tooltipItem) {
                                    return `${tooltipItem.dataset.label}: ` + new Intl.NumberFormat('en-US', {
                                        style: 'currency',
                                        currency: 'USD',
                                    }).format(tooltipItem.raw as number);
                                }
                            }
                        }
                    }
                }
            });

            this.chart.nativeElement.style.maxHeight = '60vh'; // Matches CSS max-height
        }
    }
}
